import React from 'react';
import { Box, Typography, Container, Paper, Button } from '@mui/material';
import {Link} from 'react-router-dom';
import AccessTimeIcon from '@mui/icons-material/AccessTime';

function PendingApproval() {
  return (
    <Container maxWidth="sm">
      <Box
        sx={{
          minHeight: '100vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          py: 4
        }}
      >
        <Paper
          elevation={3}
          sx={{
            p: 4,
            textAlign: 'center',
            backgroundColor: 'rgba(255, 255, 255, 0.9)',
            borderRadius: 2
          }}
        >
          <AccessTimeIcon
            sx={{
              fontSize: 64,
              color: 'primary.main',
              mb: 2
            }}
          />
          <Typography variant="h4" component="h1" gutterBottom>
            Account Pending Approval
          </Typography>
          <Typography variant="body1" color="text.secondary" paragraph>
            Thank you for signing up! Your account is currently pending approval from an administrator.
          </Typography>
          <Typography variant="body2" color="text.secondary">
            You will receive an email notification once your account has been approved.
          </Typography>
          
            <Button variant="contained" component={Link} to="/" color="primary" sx={{ mt: 2 }}>
              Go to Home
            </Button>
        </Paper>
      </Box>
    </Container>
  );
}

export default PendingApproval;